import React from "react";

const ProjectFilterPills = ({ categories, active, onChange }) => (
  <div className="mt-28 flex flex-wrap items-center justify-center gap-2">
    {categories.map((c) => {
      const isActive = active === c;
      const cls = isActive
        ? "border-gold text-gold bg-gold/10"
        : "border-white/10 text-themed-muted hover:text-themed hover:border-white/30";
      return (
        <button
          key={c}
          data-testid={`showcase-filter-${c.toLowerCase().replace(/\s+/g, "-")}`}
          onClick={() => onChange(c)}
          className={`text-[10px] tracking-[0.28em] uppercase px-4 py-2 rounded-full border transition-all ${cls}`}
        >
          {c}
        </button>
      );
    })}
  </div>
);

export default ProjectFilterPills;
